/**
 * TrendModa — Modern Animasyonlar & Etkileşimler
 */
(function () {
  'use strict';

  /* ===== SCROLL REVEAL ===== */
  function initScrollReveal() {
    var els = document.querySelectorAll('.tm-reveal');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('tm-revealed');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ===== PRODUCT CARD: add tm-reveal to each card ===== */
  function initCardReveal() {
    if (window.__TM_CARD_REVEAL_INIT__) return;
    window.__TM_CARD_REVEAL_INIT__ = true;
    var cards = document.querySelectorAll('.ty-card');
    cards.forEach(function (card, i) {
      card.classList.add('tm-reveal');
      card.classList.add('tm-reveal-delay-' + ((i % 4) + 1));
    });
    initScrollReveal();
  }

  /* ===== QUICK ADD (devre dışı — card-atc.js kullanılıyor) ===== */
  function initQuickAdd() { return; }
  function _initQuickAdd_DISABLED() {
    document.querySelectorAll('.ty-card').forEach(function (card) {
      var link = card.querySelector('.ty-card__image-link, .ty-card__title-link');
      var href = link ? link.getAttribute('href') : null;
      var btn = document.createElement('button');
      btn.className = 'ty-card__quick-add';
      btn.textContent = 'Sepete Ekle';
      btn.type = 'button';
      var wrapper = card.querySelector('.ty-card__image-wrapper');
      if (wrapper) wrapper.appendChild(btn);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = card.dataset.variantId;
        if (variantId) {
          btn.textContent = 'Ekleniyor...';
          btn.disabled = true;
          var cartDrawer = document.querySelector('cart-drawer');
          var sections = (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function')
            ? cartDrawer.getSectionsToRender().map(function (s) { return s.id; })
            : [];

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1, sections: sections })
          })
          .then(function (res) {
            if (!res.ok && res.status !== 422) throw new Error('network');
            return res.json();
          })
          .then(function (response) {
            if (response.status) throw new Error(response.description || 'Eklenemedi');
            btn.textContent = 'Eklendi!';
            btn.classList.add('ty-card__quick-add--added');
            spawnConfetti(e.clientX, e.clientY);
            if (cartDrawer && response.sections && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(response);
              if (typeof cartDrawer.open === 'function') cartDrawer.open();
              else cartDrawer.classList.add('active', 'animate');
            }
          })
          .catch(function () {
            btn.textContent = 'Hata — Tekrar Dene';
          })
          .finally(function () {
            btn.disabled = false;
            setTimeout(function () {
              btn.textContent = 'Sepete Ekle';
              btn.classList.remove('ty-card__quick-add--added');
            }, 2000);
          });
        } else if (href) {
          window.location.href = href;
        }
      });
    });
  }

  /* ===== CONFETTI ===== */
  var confettiColors = ['#F27A1A', '#5B21B6', '#1EA05A', '#E81E25', '#F59E0B', '#7C3AED'];
  function spawnConfetti(x, y) {
    for (var i = 0; i < 8; i++) {
      var dot = document.createElement('div');
      dot.className = 'tm-confetti-dot';
      dot.style.left = (x + (Math.random() * 60 - 30)) + 'px';
      dot.style.top = (y + (Math.random() * 20 - 10)) + 'px';
      dot.style.background = confettiColors[Math.floor(Math.random() * confettiColors.length)];
      document.body.appendChild(dot);
      setTimeout(function (d) { d.remove(); }, 800, dot);
    }
  }

  /* ===== HEART ANIMATION ===== */
  function initHeartAnimation() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-handle]');
      if (!btn) return;
      btn.classList.add('ty-card__heart--beating', 'ty-btn--heart--beating');
      setTimeout(function () {
        btn.classList.remove('ty-card__heart--beating', 'ty-btn--heart--beating');
      }, 600);
    });
  }

  /* ===== VARIANT IMAGE FADE ===== */
  function initVariantImageFade() {
    var thumbs = document.querySelectorAll('.ty-gallery__thumb');
    var mainImg = document.getElementById('tyMainImg');
    if (!thumbs.length || !mainImg) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainImg.classList.add('ty-img-fade-out');
        setTimeout(function () {
          mainImg.src = thumb.dataset.src;
          mainImg.classList.remove('ty-img-fade-out');
          thumbs.forEach(function (t) { t.classList.remove('ty-gallery__thumb--active'); });
          thumb.classList.add('ty-gallery__thumb--active');
        }, 200);
      });
    });
  }

  /* ===== BEDEN REHBERİ ===== */
  function initSizeGuide() {
    var popup = document.getElementById('tmSizeGuide');
    if (!popup) return;
    var lastSizeGuideTrigger = null;
    var backgroundSheet = null;
    function openSizeGuide(trigger) {
      lastSizeGuideTrigger = trigger;
      backgroundSheet = trigger.closest('.bottomsheet');
      if (backgroundSheet) backgroundSheet.inert = true;
      popup.inert = false;
      popup.setAttribute('aria-hidden', 'false');
      popup.classList.add('tm-size-guide--open');
      document.body.classList.add('tm-size-guide-open');
      var closeButton = popup.querySelector('.tm-size-guide__close');
      if (closeButton) closeButton.focus();
    }
    function closeSizeGuide() {
      popup.classList.remove('tm-size-guide--open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tm-size-guide-open');
      if (backgroundSheet) backgroundSheet.inert = false;
      if (lastSizeGuideTrigger && document.contains(lastSizeGuideTrigger)) lastSizeGuideTrigger.focus();
      popup.inert = true;
      backgroundSheet = null;
    }
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-open-size-guide]');
      if (trigger) {
        e.preventDefault();
        openSizeGuide(trigger);
        return;
      }
      if (e.target.closest('.tm-size-guide__close') || e.target === popup) {
        closeSizeGuide();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (!popup.classList.contains('tm-size-guide--open')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeSizeGuide();
        return;
      }
      if (e.key !== 'Tab') return;
      var focusable = popup.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  /* ===== TERK SEPETİ / EXIT INTENT ===== */
  function initExitPopup() {
    var popup = document.getElementById('tmExitPopup');
    if (!popup) return;
    if (sessionStorage.getItem('tm_exit_shown')) return;

    var triggered = false;
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY < 10 && !triggered) {
        triggered = true;
        sessionStorage.setItem('tm_exit_shown', '1');
        popup.classList.add('tm-exit-popup--open');
      }
    });

    // Mobile: back button / visibility change
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && !triggered) {
        triggered = true;
        sessionStorage.setItem('tm_exit_shown', '1');
      }
    });

    popup.addEventListener('click', function (e) {
      if (e.target === popup || e.target.closest('.tm-exit-popup__close') || e.target.closest('.tm-exit-popup__skip')) {
        popup.classList.remove('tm-exit-popup--open');
      }
    });
  }

  /* ===== FLOATING CART BAR ===== */
  function initFloatBar() {
    var bar = document.getElementById('tmFloatBar');
    if (!bar) return;

    // Show after scrolling 300px
    var shown = false;
    window.addEventListener('scroll', function () {
      if (window.scrollY > 300 && !shown) {
        shown = true;
        bar.classList.add('tm-float-bar--visible');
      }
    }, { passive: true });

    var closeBtn = bar.querySelector('.tm-float-bar__close');
    if (closeBtn) closeBtn.addEventListener('click', function () {
      bar.classList.remove('tm-float-bar--visible');
    });
  }

  /* ===== COUNT-UP ANIMATION ===== */
  function initCountUp() {
    var els = document.querySelectorAll('[data-count-up]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var target = parseFloat(el.dataset.countUp);
        var suffix = el.dataset.countSuffix || '';
        var prefix = el.dataset.countPrefix || '';
        var duration = 1500;
        var start = performance.now();
        function step(now) {
          var progress = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var val = Math.round(eased * target);
          el.textContent = prefix + val.toLocaleString('tr-TR') + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        io.unobserve(el);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ===== INIT ALL ===== */
  function init() {
    initCardReveal();
    initQuickAdd();
    initHeartAnimation();
    initVariantImageFade();
    initSizeGuide();
    initExitPopup();
    initFloatBar();
    initCountUp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
